/** API route map: URLS.Controller.EmployeeBankDetails */
export const EmployeeBankDetails = {
      Name: 'EmployeeBankDetail/',
      GetAll: 'employee-bank-detail',
      AddEmployeeBank: 'add-employee-bank',
      UpdateEmployeeBank: 'update',
      DeleteEmployeeBank: 'delete/',
      CheckEmployeeBank: 'check-employee-bank/',
      MarkAsPrimary: 'mark-as-primary/',
      GetAllBankAccountsTransistNumberLink: 'get-all-bank-accounts-transistNumber/',
      ReorderBankDetail: 'reorder-bank-detail',
      GetAllBankAccounts: 'get-all-bank-accounts',
      GetAllBankAccountsTransistNumber: 'get-all-bank-accounts-transistNumber/',
      GetAllEmployeeAccounts: 'get-all-employee-bank-list/',
      GetAllLink: 'employee-bank-detail-link',
      AddEmployeeBankLink: 'add-employee-bank-link',
      UpdateEmployeeBankLink: 'update-link',
      DeleteEmployeeBankLink: 'delete-link/',
      ImporEmployeeBankDepositInfo: 'import-employee-bank-deposit-info',
};
